// Customer-facing mirror of backend/services/scc_pricing.py.
// backend/tests/test_scc_pricing.py pins these values across both runtimes.

export const SCC_BASE_PRICE = {
  staffLimit: 10,
  price: '$65',
  priceUsd: 65,
  billing: '/mo',
};

export const SCC_WORKFORCE_EXTENSIONS = [
  { key: 'staff20', title: 'Up to 20 staff', staffLimit: 20, price: '+$80', priceUsd: 80, total: '$145', billing: '/mo', totalStaff: '20 total staff' },
  { key: 'staff30', title: 'Up to 30 staff', staffLimit: 30, price: '+$200', priceUsd: 200, total: '$265', billing: '/mo', totalStaff: '30 total staff' },
  { key: 'staff40', title: 'Up to 40 staff', staffLimit: 40, price: '+$330', priceUsd: 330, total: '$395', billing: '/mo', totalStaff: '40 total staff' },
  { key: 'staff50', title: 'Up to 50 staff', staffLimit: 50, price: '+$480', priceUsd: 480, total: '$545', billing: '/mo', totalStaff: '50 total staff' },
];

export const SCC_CLOUD_OPTIONS = [
  {
    key: 'shield', eyebrow: 'ESSENTIAL MANAGED PROTECTION', title: 'SCC Cloud Shield',
    price: '$15', priceUsd: 15, billing: '/mo', recommended: false,
    items: ['Settings backup', 'Configuration backup', 'Essential business data protection', 'Managed VISINVOKE cloud protection'],
  },
  {
    key: 'guardian', eyebrow: 'RECOMMENDED FOR GROWING BUSINESSES', title: 'SCC Cloud Guardian',
    price: '$35', priceUsd: 35, billing: '/mo', recommended: true, flag: 'Recommended',
    items: ['Full business backup', 'Customer records & job history backup', 'Invoice & operational record backup', 'Document backup', 'Daily backup history & restore capability'],
  },
  {
    key: 'complete', eyebrow: 'COMPLETE MANAGED PROTECTION', title: 'SCC Cloud Complete',
    price: '$65', priceUsd: 65, billing: '/mo', recommended: false,
    items: ['Expanded backup coverage', 'Larger document protection', 'Extended retention', 'Advanced recovery capability', 'For businesses wanting the highest managed backup and recovery coverage'],
  },
];

export function sccMonthlyTotal(staffLimit = 10, cloudTier = 'none') {
  const workforce = SCC_WORKFORCE_EXTENSIONS.find((item) => item.staffLimit === Number(staffLimit));
  const cloud = SCC_CLOUD_OPTIONS.find((item) => item.key === cloudTier);
  return SCC_BASE_PRICE.priceUsd + (workforce?.priceUsd || 0) + (cloud?.priceUsd || 0);
}
